var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bingliComp"},[_c('div',{staticStyle:{"line-height":"200px","font-size":"14px","text-align":"center"}},[_vm._v("开发中")])])}]

export { render, staticRenderFns }